module.exports = "/_next/static/images/image@4x-93e848a470b96e968b9eb94ff9e42f1f.png";